import NavigationConstants from 'sharedreact/constants/NavigationConstants';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

function openSlideOut (
  view: string,
  paramName: string | null = null,
  setValue: ((key: string,  value: any) => void) | null = null,
  extraData: any | null = null
): void {
  AppDispatcher.dispatch({
    actionType: NavigationConstants.OPEN_SLIDEOUT,
    view: view,
    paramName: paramName,
    setValue: setValue,
    extraData: extraData,
    logLevel: 'trace'
  });
}

function changeSlideOut (
  view: string,
  paramName: string | null = null,
  setValue: ((key: string,  value: any) => void) | null = null,
  extraData: string | null = null
): void {
  AppDispatcher.dispatch({
    actionType: NavigationConstants.CHANGE_SLIDEOUT,
    view: view,
    paramName: paramName,
    setValue: setValue,
    extraData: extraData,
    logLevel: 'trace'
  });
}

function closeSlideOut (): void {
  AppDispatcher.dispatch({
    actionType: NavigationConstants.CLOSE_SLIDEOUT,
    logLevel: 'trace'
  });
}

function closeAllSlideOuts (): void {
  AppDispatcher.dispatch({
    actionType: NavigationConstants.CLOSE_ALL_SLIDEOUTS,
    logLevel: 'trace'
  });
}

function showDialog (
  view: string,
  paramName: string | null = null,
  setValue: ((key: string,  value: any) => void) | null = null,
  extraData: any | null = null
): void {
  AppDispatcher.dispatch({
    actionType: NavigationConstants.SHOW_DIALOG,
    view: view,
    paramName: paramName,
    setValue: setValue,
    extraData: extraData,
    logLevel: 'trace'
  });
}

function hideDialog (view: string): void {
  AppDispatcher.dispatch({
    actionType: NavigationConstants.HIDE_DIALOG,
    view: view,
    logLevel: 'trace'
  });
}

export default {
  openSlideOut,
  changeSlideOut,
  closeSlideOut,
  closeAllSlideOuts,
  showDialog,
  hideDialog
};
